<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_cardsetting_banner.jpg')" alt="出金口座の登録方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <div class="sup-cardsetting-tabs">
          <router-link class="sup-cardsetting-tab" to="/page/sup-cardsetting-bank">
            銀行口座の登録方法
          </router-link>
          <router-link class="sup-cardsetting-tab sup-cardsetting-tab--active" to="/page/sup-cardsetting-ewallet">
            eウォレットアカウントの登録方法
          </router-link>
          <router-link class="sup-cardsetting-tab" to="/page/sup-cardsetting-ewalletid">
            各決済サービスのユーザーIDの確認方法
          </router-link>
        </div>
        <h1 class="sup-page-title">
          eウォレットアカウントの登録方法
        </h1>
        <div class="sup-steps-box">
          <div class="sup-step">
            <!-- タイトル: font-size 20px, #282828, bold, center -->
            <p class="sup-step-num">
              ステップ 1
            </p>
            <!-- テキスト: font-size 14px, #978564, bold, center -->
            <div class="sup-wallet-content-list">
              <p>➊ ホーム画面の「詳細」＞「アカウント」をタップ</p>
              <p>➋ 「決済方法」をタップ</p>
            </div>
            <!-- 画像1: 300x650, border 2px solid #978564, border-radius 10px, 中央揃え -->
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_ewallet1.jpg')" alt="ステップ1-1 ホーム画面アカウント">
            </div>
            <!-- 画像2: 300x650 -->
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_ewallet2.jpg')" alt="ステップ1-2 決済方法">
            </div>
          </div>

          <!-- 区切り線 -->
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <!-- テキスト1行: font-size 14px, #978564, bold, center -->
            <p class="sup-step-desc">
              「口座を追加」をタップ
            </p>
            <!-- 画像: 300x650 -->
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_ewallet3.jpg')" alt="ステップ2 口座を追加">
            </div>
          </div>

          <!-- 区切り線 -->
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 3
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 決済方法：「eウォレット」を選択</p>
              <p>➋ 決済サービス：利用する「eウォレット」を選択</p>
              <p>➌ 口座名義：本人名義をカタカナで入力</p>
              <p>➍ 決済サービスのユーザーID：利用する「決済サービスのユーザーID」を入力</p>
              <p>➎ 決済サービスのユーザーID（確認用）：利用する「決済サービスのユーザーID」を再入力</p>
              <p>➏ 「確認」をタップすると、登録完了</p>
            </div>
            <!-- 画像: 300x650 -->
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_cardsetting_ewallet4.jpg')" alt="ステップ3 eウォレット登録フォーム">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
